var _g, _clipPath, _clipPath2, _clipPath3, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer6Winter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 1067",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-6",
    serifId: "layer 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer-61",
    serifId: "layer 6"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "city-2",
    serifId: "city 2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "city-3",
    serifId: "city 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1687.7,448.761c0,-1.42 -0.553,-2.783 -1.541,-3.801c-2.932,-3.02 -9.27,-9.547 -12.088,-12.449c-0.894,-0.921 -2.122,-1.44 -3.406,-1.44c-3.987,-0 -12.871,-0 -16.947,-0c-1.347,-0 -2.632,0.573 -3.532,1.575c-2.672,2.975 -8.43,9.386 -11.089,12.346c-0.899,1.001 -1.397,2.3 -1.397,3.646c0,10.294 0,55.732 0,71.556c0,3.013 2.443,5.456 5.457,5.456c9.616,-0 29.471,-0 39.087,-0c3.014,-0 5.456,-2.443 5.456,-5.456c0,-15.762 0,-60.907 0,-71.433Z",
    style: {
      fill: "#bedce8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.04,475.483c-0,-3.013 -2.443,-5.456 -5.456,-5.456c-5.217,0 -13.038,0 -18.255,0c-3.013,0 -5.456,2.443 -5.456,5.456c0,14.473 0,53.718 0,68.19c0,3.014 2.443,5.457 5.456,5.457c5.217,-0 13.038,-0 18.255,-0c3.013,-0 5.456,-2.443 5.456,-5.457c-0,-14.472 -0,-53.717 -0,-68.19Z",
    style: {
      fill: "#bedce8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.71,440.58c-0.34,-1.48 -1.658,-2.53 -3.177,-2.53c-1.519,0 -2.837,1.049 -3.177,2.53c-3.68,15.041 -9.242,39.957 -9.242,53.123c-0,12.211 5.564,22.125 12.419,22.125c6.854,0 12.419,-9.914 12.419,-22.125c0,-13.166 -5.562,-38.082 -9.242,-53.123Z",
    style: {
      fill: "#bedce8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.34,418.875c-0.391,-1.411 -1.675,-2.387 -3.14,-2.387c-1.464,-0.001 -2.748,0.976 -3.14,2.387c-4.286,14.728 -11.443,41.383 -11.443,55.165c0,12.212 6.535,22.126 14.583,22.126c8.049,-0 14.584,-9.914 14.584,-22.126c-0,-13.782 -7.157,-40.437 -11.444,-55.165Z",
    style: {
      fill: "#bedce8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "trees-5",
    serifId: "trees 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2490.84,241.792c-0.391,-1.411 -1.675,-2.388 -3.14,-2.388c-1.464,0 -2.748,0.977 -3.14,2.388c-4.286,14.728 -11.443,41.383 -11.443,55.165c0,12.211 6.535,22.125 14.583,22.125c8.049,0 14.584,-9.914 14.584,-22.125c-0,-13.782 -7.157,-40.437 -11.444,-55.165Z",
    style: {
      fill: "#b0d4e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2515.79,210.086c-0.451,-1.318 -1.69,-2.204 -3.083,-2.204c-1.393,-0 -2.632,0.885 -3.082,2.204c-5.322,15.092 -15.668,46.46 -15.668,62.219c0,13.169 8.402,23.861 18.75,23.861c10.349,-0 18.75,-10.692 18.75,-23.861c0,-15.759 -10.345,-47.127 -15.667,-62.219Z",
    style: {
      fill: "#b0d4e3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.334,101.262l17.238,-16.586c0.794,-0.765 1.902,-1.112 2.991,-0.937c1.089,0.175 2.032,0.852 2.547,1.827c4.817,9.118 16.155,30.58 18.801,35.591c0.368,0.695 0.56,1.47 0.56,2.256c-0,6.971 -0,42.012 -0,42.012l-36.641,0c-0.216,0.57 -0.541,1.099 -0.963,1.557c-0.913,0.991 -2.198,1.555 -3.546,1.557c-11.254,0.015 -36.764,0.049 -36.764,0.049c-0,0 -0,-37.127 -0,-43.194c-0,-0.552 0.095,-1.1 0.28,-1.62c1.51,-4.243 8.707,-24.47 10.965,-30.817c0.177,-0.495 0.55,-0.895 1.031,-1.105c0.482,-0.211 1.029,-0.213 1.512,-0.006l12.742,5.456l0,-7.551c0,-1.632 1.323,-2.954 2.954,-2.954c0.002,-0 0.003,-0 0.005,-0c1.631,-0 2.954,1.322 2.954,2.954l0,10.083l3.334,1.428Z",
    style: {
      fill: "#b0d4e3"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.334,101.262l17.238,-16.586c0.794,-0.765 1.902,-1.112 2.991,-0.937c1.089,0.175 2.032,0.852 2.547,1.827c4.817,9.118 16.155,30.58 18.801,35.591c0.368,0.695 0.56,1.47 0.56,2.256c-0,6.971 -0,42.012 -0,42.012l-36.641,0c-0.216,0.57 -0.541,1.099 -0.963,1.557c-0.913,0.991 -2.198,1.555 -3.546,1.557c-11.254,0.015 -36.764,0.049 -36.764,0.049c-0,0 -0,-37.127 -0,-43.194c-0,-0.552 0.095,-1.1 0.28,-1.62c1.51,-4.243 8.707,-24.47 10.965,-30.817c0.177,-0.495 0.55,-0.895 1.031,-1.105c0.482,-0.211 1.029,-0.213 1.512,-0.006l12.742,5.456l0,-7.551c0,-1.632 1.323,-2.954 2.954,-2.954c0.002,-0 0.003,-0 0.005,-0c1.631,-0 2.954,1.322 2.954,2.954l0,10.083l3.334,1.428Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.249,124.946c-0.004,-0.463 -0.118,-0.917 -0.333,-1.327c-1.89,-3.603 -11.435,-21.795 -14.249,-27.159c-0.156,-0.297 -0.462,-0.485 -0.798,-0.491c-0.336,-0.005 -0.648,0.173 -0.813,0.465c-3.032,5.353 -13.446,23.737 -15.557,27.464c-0.246,0.434 -0.375,0.924 -0.375,1.423c-0,5.591 -0,40.104 -0,40.104l32.473,-0.006c0,0 -0.301,-35.042 -0.348,-40.473Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.847,111.805c0.482,1.971 1.215,3.656 2.397,4.995c7.814,8.852 15.102,-1.659 22.368,-5.03c3.424,-1.588 5.619,0.884 8.832,1.899c2.776,0.877 5.353,0.418 7.936,-1.107c4.795,-2.83 7.399,-9.89 11.414,-14.093c3.85,-4.03 9.171,-4.645 13.004,-8.466c2.964,-2.953 2.208,-8.101 -0.314,-11.067c-1.116,-1.313 -2.4,-2.55 -3.712,-3.482c-1.921,-1.366 -4.017,-2.095 -6.141,-2.611c-3.536,-0.859 -7.158,-1.149 -10.749,-1.092c-5.988,0.096 -12.203,1.351 -17.945,3.599c-11.023,4.315 -20.505,13.806 -25.092,28.356",
    style: {
      fill: "#fff",
      fillOpacity: 0.73
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.408,69.912c0.408,0.665 1.132,1.071 1.912,1.071c0.781,-0 1.505,-0.406 1.913,-1.071c3.873,-6.116 12.281,-20.192 12.281,-27.139c-0,-7.548 -6.36,-13.676 -14.194,-13.676c-7.833,-0 -14.193,6.128 -14.193,13.676c-0,6.947 8.407,21.023 12.281,27.139Z",
    style: {
      fill: "#b0d4e3"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.408,69.912c0.408,0.665 1.132,1.071 1.912,1.071c0.781,-0 1.505,-0.406 1.913,-1.071c3.873,-6.116 12.281,-20.192 12.281,-27.139c-0,-7.548 -6.36,-13.676 -14.194,-13.676c-7.833,-0 -14.193,6.128 -14.193,13.676c-0,6.947 8.407,21.023 12.281,27.139Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.111,39.375c-1.509,1.509 -1.509,3.956 -0,5.465c1.509,1.508 3.955,1.508 5.464,-0l2.691,-2.691c0.274,-0.275 0.719,-0.275 0.993,-0c0.274,0.274 0.274,0.719 0,0.994l-1.934,1.934c1.518,1.267 3.779,1.188 5.204,-0.237c1.51,-1.509 1.51,-3.956 0,-5.465c-1.508,-1.509 -3.955,-1.509 -5.464,0l-2.69,2.691c-0.274,0.274 -0.719,0.274 -0.994,0c-0.274,-0.274 -0.274,-0.719 -0,-0.993l1.934,-1.935c-1.518,-1.267 -3.779,-1.188 -5.204,0.237Zm6.21,-1.226c-2.07,-1.822 -5.227,-1.744 -7.204,0.233c-2.057,2.058 -2.057,5.393 0,7.451c1.977,1.977 5.134,2.054 7.204,0.233c2.069,1.821 5.226,1.744 7.202,-0.233c2.057,-2.058 2.057,-5.393 0,-7.451c-1.976,-1.977 -5.133,-2.055 -7.202,-0.233Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "mountains-5",
    serifId: "mountains 5",
    d: "M0,101.906c0,0 146.058,66.566 206.25,60.642c68.912,-6.782 103.467,-169.737 193.75,-147.013c120.43,30.312 137.251,281.702 269.792,365.715c55.804,35.373 82.461,-64.711 159.375,-47.917c115.542,25.229 195.228,308.785 438.541,318.75c259.54,10.631 386.165,-204.459 552.084,-214.762c147.693,-9.172 268.531,162.27 406.933,99.823c175.787,-79.314 323.648,-373.623 412.858,-396.719c103.805,-26.874 115.709,147.665 187.364,132.086c116.276,-25.281 173.053,-272.511 173.053,-272.511l-0,1066.92l-3000,0l-0.002,-965.017Z",
    style: {
      fill: "url(#_Linear3)",
      fillRule: "nonzero"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,101.906c0,0 146.058,66.566 206.25,60.642c68.912,-6.782 103.467,-169.737 193.75,-147.013c120.43,30.312 137.251,281.702 269.792,365.715c55.804,35.373 82.461,-64.711 159.375,-47.917c115.542,25.229 195.228,308.785 438.541,318.75c259.54,10.631 386.165,-204.459 552.084,-214.762c147.693,-9.172 268.531,162.27 406.933,99.823c175.787,-79.314 323.648,-373.623 412.858,-396.719c103.805,-26.874 115.709,147.665 187.364,132.086c116.276,-25.281 173.053,-272.511 173.053,-272.511l-0,1066.92l-3000,0l-0.002,-965.017Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.103,56.347c11.29,-3.959 15.999,2.886 17.146,14.748c1.286,13.307 -5.331,26.706 -3.223,40.002c1.616,10.2 11.348,16.07 20.236,9.373c14.438,-10.877 19.48,-36.531 42.11,-32.012c21.103,4.214 24.654,30.932 43.526,38.235c16.451,6.366 28.544,-16.966 45.19,-8.235c15.326,8.039 20.067,28.673 38.163,32.948c2.388,0.564 13.721,3.585 14.903,0.792c3.687,-8.712 -0.661,-19.477 -3.356,-27.813c-5.448,-16.849 -10.872,-33.718 -17.173,-50.272c-10.222,-26.854 -40.92,-69.912 -66.392,-85.401c-44.532,-27.079 -101.263,-18.657 -129.401,27.004c-9.318,15.12 -13.111,32.21 -16.833,49.312",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.581,160.098c34.752,8.264 88.356,21.358 51.558,46.609c-13.462,9.238 3.285,29.049 41.609,40.448c70.688,21.024 188.514,29.278 192.653,37.292c6.989,13.532 -50.567,18.835 -29.366,47.2c11.311,15.133 127.731,46.782 201.82,52.979c-13.003,-7.368 -28.094,-20.621 -28.094,-20.621c-51.393,-9.708 -158.356,-30.131 -158.556,-45.559c-0.199,-15.285 62.345,-24.976 24.093,-44.112c-32.945,-16.482 -260.882,-33.999 -220.481,-70.718c22.997,-20.901 -9.846,-36.981 -70.159,-51.477l-5.077,7.959Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2570.86,167.699c13.569,3.017 15.759,21.682 18.363,33.147c0.948,4.173 2.101,11.36 6.364,13.676c4.387,2.384 9.621,-2.534 11.763,-5.781c4.834,-7.326 9.413,-22.756 21.105,-20.596c7.494,1.385 12.17,10.249 14.279,16.75c4.514,13.913 5.339,37.968 21.969,42.93c23.581,7.037 19.549,-28.573 41.19,-30.454c14.416,-1.253 21.878,15.007 33.239,21.168c8.21,4.452 16.638,4.43 21.906,-4.181c10.075,-16.469 -8.119,-40.727 -17.357,-53.826c-2.428,-3.442 -5.074,-6.604 -7.772,-9.836c-24.447,-29.277 -60.256,-49.869 -99.388,-45.443c-9.281,1.05 -18.273,4.523 -26.731,8.279c-10.807,4.8 -22.649,9.015 -29.903,19.023c-2.759,3.806 -3.329,8.053 -5.227,12.263",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.64,458.803c4.445,19.407 15.302,50.011 40.448,46.839c15.001,-1.892 28.105,-14.031 43.85,-10.288c6.68,1.588 11.079,6.751 15.843,11.292c7.718,7.359 17.404,13.871 28.515,10.678c21.552,-6.193 31.985,-34.462 56.272,-33.768c23.159,0.662 34.5,22.419 53.383,31.672c34.619,16.964 76.773,-3.781 102.698,-27.348c8.351,-7.592 -7.623,-19.865 -15.025,-26.555c-19.405,-17.538 -44.372,-29.795 -69.349,-36.972c-17.322,-4.977 -35.373,-8.12 -53.177,-10.803c-54.328,-8.187 -116.286,-10.026 -162.783,24.175c-10.497,7.72 -18.907,17.344 -26.503,27.827",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.861,374.442c16.4,1.942 32.295,-11.052 48.346,-5.308c17.99,6.437 23.158,29.942 45.328,29.583c6.482,-0.105 12.967,-1.808 18.553,-5.162c9.637,-5.784 16.117,-15.437 27.024,-19.404c10.287,-3.742 18.922,0.548 28.901,2.549c-1.155,-4.859 -2.741,-9.128 -3.238,-10.895c-4.01,-14.258 -17.745,-26.915 -30.547,-34.918c-4.169,-2.606 -8.669,-4.898 -13.218,-6.872c-5.502,-2.388 -11.229,-4.364 -17.193,-5.462c-7.017,-1.292 -14.783,-1.537 -21.918,-1.004c-13.816,1.031 -26.171,5.657 -38.592,11.069c-16.061,6.998 -37.986,29.843 -43.516,45.816c0.024,0.003 0.047,0.006 0.07,0.008Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.54062,1053.75,-1053.75,3.54062,1291.87,160.577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b0d4e3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#c7e1eb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer6Winter);
export default __webpack_public_path__ + "static/media/layer6-winter.f4553e4d2e8100afb3e8ee921258b325.svg";
export { ForwardRef as ReactComponent };